var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"clickeable"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGeo),expression:"showGeo"}],staticClass:"fa-stack fa-2x",on:{"click":_vm.goGeocode}},[_c('i',{staticClass:"fas fa-map-marked-alt fa-stack-2x"}),_c('i',{staticClass:"fas fa-map-marker-alt fa-stack-1x point-map"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }